export const mainPageType = 'zmt';

// 稿源页type
export const sourcePageType = 'source';

export const personalPageType = 'personalPage';

export const personalCommentType = 'dynamicsDetail';

export const source_type = 'weMedia';

export const pop_softinput = false;

export const nav = [
    {
        name: '文章',
        tag: 'doc',
    },
    {
        name: '视频 ',
        tag: 'video',
    },
];
